export default "__VITE_ASSET__f8d050a8__"